import React, {useState, useEffect} from 'react';
import axios from 'axios';


const ContactIcon = () => {

    const [phoneicon, setPhoneicon] = useState([]);

    useEffect(()=>{
        axios.get("https://www.cadandrender.com/adminPanel/API/contact.php").then((response)=>{
            setPhoneicon(response.data.Contact);
      })
    },[]);

    return(
        <>
        <div className='ContactIcon'>
        {phoneicon.map((res)=>
        <>
            <a href={`tel: ${res.CadContact_ContactNumber}`}><i className='fa fa-phone'></i></a>
        </>
        )}
        </div>
        </>
    );
}


export default ContactIcon;